(function() {
  var indexOf = [].indexOf || function(item) { for (var i = 0, l = this.length; i < l; i++) { if (i in this && this[i] === item) return i; } return -1; };

  exports.DependencyInjection = (function() {
    function DependencyInjection() {
      var ref;
      this.parent = (ref = this.parent) != null ? ref : null;
      this.dependencies = {};
      this._ignore_properties = ['parent', 'dependencies', '_ignore_properties', '_keep_properties', '_transform_properties'];
      this._keep_properties = [];
      this._transform_properties = [
        function(v) {
          if (v instanceof TAFFY) {
            v = v().get();
          }
          return v;
        }, function(v) {
          return ko.utils.unwrapObservable(v);
        }
      ];
      this.setInitialDeps();
    }

    DependencyInjection.prototype.ignore = function(arr) {
      var l, len, results, v;
      if (!$.isArray(arr)) {
        arr = [arr];
      }
      results = [];
      for (l = 0, len = arr.length; l < len; l++) {
        v = arr[l];
        results.push(this._ignore_properties.push(v));
      }
      return results;
    };

    DependencyInjection.prototype.keep = function(arr) {
      var l, len, results, v;
      if (!$.isArray(arr)) {
        arr = [arr];
      }
      results = [];
      for (l = 0, len = arr.length; l < len; l++) {
        v = arr[l];
        results.push(this._keep_properties.push(v));
      }
      return results;
    };

    DependencyInjection.prototype.transform = function(arr) {
      var l, len, results, v;
      if (!$.isArray(arr)) {
        arr = [arr];
      }
      results = [];
      for (l = 0, len = arr.length; l < len; l++) {
        v = arr[l];
        results.push(this._transform_properties.push(v));
      }
      return results;
    };


    /*
    This recursively cleans up KoModels for
    serialization. It'll remove any unwanted properties,
    or only keep ones you specifically want to keep.
    
    This is great, because it makes life a lot easier
    for handling data models that might be serialized
     */

    DependencyInjection.prototype._cleanUp = function() {
      var copy, definitely_ignore_keys, fn, i, j, key, l, len, len1, m, ref, v;
      definitely_ignore_keys = ['dependencies', 'parent', '_ignore_properties', '_keep_properties', '_transform_properties'];
      copy = $.extend(true, {}, this);
      for (key in copy) {
        v = copy[key];
        ref = this._transform_properties;
        for (l = 0, len = ref.length; l < len; l++) {
          fn = ref[l];
          v = fn(v, key);
        }
        copy[key] = v;
        if (indexOf.call(this._ignore_properties, key) >= 0 || indexOf.call(definitely_ignore_keys, key) >= 0 || (this._keep_properties.length > 0 && indexOf.call(this._keep_properties, key) < 0)) {
          copy[key] = null;
          delete copy[key];
        } else if (v instanceof DependencyInjection) {
          copy[key] = v._cleanUp();
        } else if ($.isArray(v)) {
          copy[key] = [];
          for (i = m = 0, len1 = v.length; m < len1; i = ++m) {
            j = v[i];
            if (j instanceof DependencyInjection) {
              copy[key][i] = j._cleanUp();
            } else {
              copy[key][i] = j;
            }
          }
        } else if ($.isPlainObject(v)) {
          copy[key] = {};
          for (i in v) {
            j = v[i];
            if (j instanceof DependencyInjection) {
              copy[key][i] = j._cleanUp();
            } else {
              copy[key][i] = j;
            }
          }
        } else if ($.isFunction(v)) {
          copy[key] = null;
          delete copy[key];
        }
      }
      return copy;
    };

    DependencyInjection.prototype.serialize = function() {
      return JSON.stringify(this._cleanUp());
    };

    DependencyInjection.prototype.syncDeps = function(list) {
      var k, results, v;
      results = [];
      for (k in list) {
        v = list[k];
        results.push(this.dependencies[k] = v);
      }
      return results;
    };

    DependencyInjection.prototype.getDep = function(name) {
      var cls;
      if ((this.parent != null) && this.parent instanceof DependencyInjection) {
        cls = this.parent.getDep(name);
        if (cls) {
          return cls;
        }
      }
      if (this.dependencies[name] == null) {
        return false;
      }
      if (typeof this.dependencies[name] === 'string') {
        return App.loadClass(this.dependencies[name]);
      }
      return this.dependencies[name];
    };

    DependencyInjection.prototype.setInitialDeps = function() {
      return void 0;
    };

    DependencyInjection.prototype["implements"] = function() {
      var iface, ifaceName, k, l, len, method, methods, obj, results, v;
      results = [];
      for (l = 0, len = arguments.length; l < len; l++) {
        iface = arguments[l];
        if (iface instanceof Array) {
          methods = iface;
          ifaceName = 'Array';
        } else if (typeof iface === 'function') {
          obj = new iface();
          methods = (function() {
            var results1;
            results1 = [];
            for (k in obj) {
              v = obj[k];
              if (typeof v === 'function') {
                results1.push(k);
              }
            }
            return results1;
          })();
          ifaceName = obj.constructor.name;
        } else if (iface instanceof Object) {
          methods = (function() {
            var results1;
            results1 = [];
            for (k in iface) {
              v = iface[k];
              if (typeof v === 'function') {
                results1.push(k);
              }
            }
            return results1;
          })();
          ifaceName = iface.constructor.name;
        } else {
          throw new Error("Invalid interface '" + iface + "'");
        }
        results.push((function() {
          var len1, m, results1;
          results1 = [];
          for (m = 0, len1 = methods.length; m < len1; m++) {
            method = methods[m];
            if (typeof method !== 'string') {
              throw new Error("Invalid method name '" + method + "' in interface '" + ifaceName + "'");
            }
            if (method.charAt(0) === '_') {
              throw new Error("Interfaces cannot specify private methods: method '" + method + "' in interface '" + ifaceName + "'");
            }
            if (this[method] == null) {
              throw new Error("Method '" + method + "' of interface '" + ifaceName + "' is not implemented");
            }
            if (typeof this[method] !== 'function') {
              throw new Error("Method '" + method + "' of interface '" + ifaceName + "' must be implemented as type 'function', not as type '" + (typeof this[method]) + "'");
            } else {
              results1.push(void 0);
            }
          }
          return results1;
        }).call(this));
      }
      return results;
    };

    return DependencyInjection;

  })();

}).call(this);
